// client/src/components/wetakeover/ProgressIndicator.jsx
import React from 'react';

const stepLabels = ['Tier', 'Creators', 'QRTs', 'Review', 'Payment', 'Setup'];

const ProgressIndicator = ({ currentStep, totalSteps = 6 }) => {
  return (
    <div className="mb-12">
      {/* Desktop: Full progress with labels */}
      <div className="hidden md:block">
        <div className="flex items-center justify-between max-w-4xl mx-auto mb-6">
          {stepLabels.map((label, index) => (
            <div key={index} className="flex flex-col items-center gap-3">
              {/* Step Circle */}
              <div
                className={`w-12 h-12 rounded-full flex items-center justify-center border-2 transition-colors ${
                  index + 1 === currentStep
                    ? 'bg-yellow-300 border-yellow-300 text-black'
                    : index + 1 < currentStep
                    ? 'bg-yellow-300/20 border-yellow-300 text-yellow-300'
                    : 'bg-white/5 border-white/20 text-white/50'
                }`}
              >
                {index + 1 < currentStep ? (
                  <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 20 20">
                    <path
                      fillRule="evenodd"
                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                      clipRule="evenodd"
                    />
                  </svg>
                ) : (
                  index + 1
                )}
              </div>

              {/* Step Label */}
              <span
                className={`text-xs font-medium uppercase tracking-wide ${
                  index + 1 === currentStep ? 'text-yellow-300' : 'text-white/50'
                }`}
              >
                {label}
              </span>
            </div>
          ))}
        </div>

        {/* Progress Bar */}
        <div className="h-1 bg-white/10 rounded-full max-w-4xl mx-auto overflow-hidden">
          <div
            className="h-full bg-yellow-300 ui-motion-progress"
            style={{ width: `${(currentStep / totalSteps) * 100}%` }}
          />
        </div>
      </div>

      {/* Mobile: Compact dots */}
      <div className="md:hidden">
        <div className="flex items-center justify-center gap-2 mb-4">
          {Array.from({ length: totalSteps }).map((_, index) => (
            <div
              key={index}
              className={`rounded-full ui-motion-progress ${
                index + 1 === currentStep
                  ? 'w-8 h-2 bg-yellow-300'
                  : index + 1 < currentStep
                  ? 'w-2 h-2 bg-yellow-300/50'
                  : 'w-2 h-2 bg-white/20'
              }`}
            />
          ))}
        </div>

        {/* Step Text */}
        <p className="text-center text-sm text-white/70">
          Step {currentStep} of {totalSteps}: {stepLabels[currentStep - 1]}
        </p>
      </div>
    </div>
  );
};

export default ProgressIndicator;
